import React from "react";
import arrow from "../../images/Svg/ArrowIcon.svg";
import { BlogData } from "../../pages/Blog/Blog.data";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";
const parse = require("html-react-parser");

const BlogDown = ({ data }) => {
  return (
    <Fade cascade duration={1000}>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:lg:grid-cols-3 gap-7 spac-y-4 w-full mb-[100px]">
        {data.map((data, index) => (
          <a href={`/blogs/${index}`} className="cursor-pointer">
            <div>
              <div>
                <div
                  href={`/blogs/${index}`}
                  className="flex text-[#161616] text-[14px] cursor-pointer"
                >
                  <img
                    className="mb-4 h-full w-full"
                    src={data.thumPhoto}
                    alt=""
                  />
                </div>
              </div>
              <div>
                <div>
                  <h1 className="text-black text-[20px] font-bold">
                    {parse(data.title)}
                  </h1>
                </div>
                <p className="pt-[16px] text-[14px] md:text-[16px] text-[#161616]">
                  {data.text}
                </p>
                <button className="flex items-center border-[#E1E1E1] border p-6 font-normal h-[40px] rounded-[8px] hover:shadow-md w-[100%] justify-center mt-4">
                  <span className="text-[14px] text-[#161616]">Read Blog</span>{" "}
                  <img className="mx-3 w-[12px] h-[12px]" src={arrow} alt="" />
                </button>
              </div>
            </div>
          </a>
        ))}
      </div>
    </Fade>
  );
};

export default BlogDown;
